import React from 'react'

const Layout = (ctx) => {
  const { children, brand, homeUrl, logoOveride, backgroundColor } = ctx
  const siteUrl = homeUrl || process.env.REACT_APP_SITE_URL

  return <div className={brand}>
    { logoOveride ?  <div className="hero">
      <div className="hero-body">
        <div className="content container custom-logo-header">
          <a href={siteUrl} title="Track Night">
            <img src={logoOveride} className="custom-logo" />
          </a>
      </div>
      </div>
    </div> :
    <section className="hero is-dark">
      <div className="hero-body">
        <div className="content container">
            <a href={siteUrl} title="Track Night">
               <h1 className="title"> </h1>
            </a>
        </div>
      </div>
    </section>
    }
    <div>
      {children}
    </div>
    <footer className="footer">
      <div className="content container">
        <div className="columns">
          <div className="column footer-section">
            <h1>Main Navigation</h1>
            <ul>
              <li>
                <a href={siteUrl}>Home</a>
              </li>
              <li>
                <a href={`${siteUrl}/faq`}>How it works</a>
              </li>
              <li>
                <a href={`${siteUrl}/virtual-horse-race-nights`}>Horse Race Nights</a>
              </li>
              <li>
                <a href={`${siteUrl}/virtual-office-parties`}>Remote Work Parties</a>
              </li>
              <li>
                <a href={`${siteUrl}/privacy`}>Privacy</a>
              </li>
              <li>
                <a href={`${siteUrl}/contact`}>Contact us</a>
              </li>
            </ul>
          </div>
          <div className="column footer-section">
            <h1>Follow Us</h1>
            <ul className="social-links">
              <li>
                <a href="https://www.instagram.com/tracknight_com/">
                  <i className="fab fa-instagram" />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/TrackNight_com">
                  <i className="fab fa-twitter" />
                </a>
              </li>
              <li>
                 <a href={`${siteUrl}/contact`}>
                  <i className="far fa-envelope" />
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/Track-Night-103128801656647/">
                  <i className="fab fa-facebook" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="has-text-centered">Copyright track-night.com &copy; 2021 - <a href="https://find-and-update.company-information.service.gov.uk/company/13050425">Reg No. 13050425</a></div>
      </div>
    </footer>
    <style jsx>{`
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@1,300&display=swap');
    .custom-logo-header {
      padding:5px;
      text-align: center;
      background-color: ${backgroundColor || '#333'}
    }
    .custom-logo {
      max-width:100%;
      max-height: 400px;
    }
    .hero-body {
      padding: 0.75em 1.5em 1.5em 1.5em;
    }
        .footer-section h1 {
          font-size: 1em;
          border-bottom: solid 5px #6d6d6d;
          padding-bottom: 5px;
        }
        .footer-section ul {
          list-style: none;
          margin-left: 0;
        }
        .footer-section ul ul {
          margin-left: 1em;
        }
        .social-links li {
          display: inline;
          font-size: 2em;
          padding-right: 1em;
        }
        .footer {
          background-color: #fafafa;
        }
        .footerLinks {
          margin-bottom: 1em;
          margin-left: 0;
        }
        .footerLinks li {
          display: inline-block;
          border-left: solid 1px #4a4a4a;
          padding: 0em 1em;
        }
        .footerLinks li:first-child {
          border-left: 0;
        }

    .hero-body h1 {
      background: url(/tn-logo-with-text-1.png) left no-repeat;
      background-size: 450px;
      width: 100%;
      height: 80px;
      margin-bottom:0;
    }
    .atr .hero-body h1 {
      background: url(/atr1.png) left no-repeat;
      background-size: 450px;
      width: 100%;
      height: 80px;
      margin-bottom:0;
    }
    @media(max-width: 550px) {
      .hero-body h1 {
        background: url(/tn-logo-with-text-2.png) left no-repeat;
        background-size: 250px;
        height: 60px;
      }
      .atr .hero-body h1 {
        background: url(/atr2.png) left no-repeat;
        background-size: 450px;
        height: 80px;
      }
    }
    .header-links ul {
          padding-top: 10px;
          list-style: none;
          padding-left:0;
          margin-left: 0;

    }
        .header-links li {
          padding-left:0;
          display: inline;
          font-size: 1.2em;
        }
        .header-links li:first-child {
          padding-right: 1.5em;
          }
     .header-links   a { color: #ffecbc}
    .right-when-big {
      text-align:right;
    }
    @media(max-width: 768px) {
    .header-links ul {
          display:none;
          padding-top: 0px;
          }
    .right-when-big {
      display:none;
    }
    }
    `}</style>
    <style global jsx>{`
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap');
      body {
        font-family: 'Noto Sans JP', sans-serif;
      }
    p { margin-bottom: 1em; }
    `}</style>
  </div>
}

export default Layout;

